export default [
  {
    path: '/agreement',
    name: 'agreement',
    redirect: '/agreement/privacyIndex',
    meta: {
      title: '协议',
    },
    children: [
      {
        path: 'privacyIndex',
        name: 'privacyIndex',
        component: () => import('@/views/agreement/PrivacyIndex.vue'),
        meta: {
          title: '用户服务协议',
        },
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/views/agreement/Privacy.vue'),
        meta: {
          title: '隐私协议',
        },
      },
      {
        path: 'collectIntro',
        name: 'collectIntro',
        component: () => import('@/views/agreement/CollectIntro.vue'),
        meta: {
          title: '信息采集说明',
        },
      },
    ],
  },
]
